import { render, staticRenderFns } from "./indexBottom.vue?vue&type=template&id=7a16064d&scoped=true&"
import script from "./indexBottom.vue?vue&type=script&lang=js&"
export * from "./indexBottom.vue?vue&type=script&lang=js&"
import style0 from "./indexBottom.vue?vue&type=style&index=0&id=7a16064d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a16064d",
  null
  
)

export default component.exports